import React, { useEffect, useRef, useState } from "react";
import { Form, Formik, useFormikContext } from "formik";
import * as Yup from "yup";
import { storeIdAction } from "../../../redux/actions/general-action";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import { storeDetailsAction } from "../../../redux/actions/invoices-action";
import successToast from "../../helper-components/success-toast";
import errorToast from "../../helper-components/error-toast";
import {
  salesCreditEditAction,
  salesCreditReceiptCreateAction,
} from "../../../redux/actions/sales-action";
import moment from "moment";
import { useHotkeys } from "react-hotkeys-hook";
import { handlea4Print } from "../../helper-components/helper-function";
import SalesPurchaseFooter from "../sales-purchase-footer";
import SalesPurchaseNavbar from "../sales-purchase-navbar";
import SalesItemsSection from "../sales-items-sec";
import SalesRCNBatchesPanel from "../sales-retun-cn-batches-panel";
const CreateEditViewSalesCN = ({
  isClone = false,

  orderDetail = [],
  vendorDetails = [],
  type = "",
  page = "",
  disabled = false,
  data,
  standAlone = false,
  payto,
  shipto,
  pageType,
  clickedplus,
  onUnsavedChangesChange,
  onFormSaved,
  hasUnsavedChanges,
  isFormSaved,
  isNotViewOnly = true,
}) => {
  const [heading, setHeading] = useState([]);
  const num0 = (v) => {
  if (v === null || v === undefined) return 0;

  if (typeof v === "number") return Number.isFinite(v) ? v : 0;

  if (typeof v === "string") {
    const s = v.trim();
    if (!s) return 0;

    // handles: "1,234.50", "12%", "₹ 99.9"
    const cleaned = s.replace(/,/g, "").replace(/[^0-9.-]/g, "");
    if (!cleaned || cleaned === "-" || cleaned === "." || cleaned === "-.") return 0;

    const n = Number(cleaned);
    return Number.isFinite(n) ? n : 0;
  }

  // booleans/objects/etc
  return 0;
};

const int0 = (v) => Math.trunc(num0(v));
  const [buttonLoading, setButtonLoading] = useState(false);

  const searchRef = useRef(null);
  const [tcsTdsAmount, setTcsTdsAmount] = useState("");

  const [addbatch, setAddbatch] = useState(false);
  const [itemId, setItemId] = useState(null);
  const initialData = {
    sl_no: 1,
    item_code: "",
    item_generic_name: "",
    item_name: "",
    item_hsn: "",
    item_manufacturer_name: "",
    item_uom: "",
    item_to_be_delivered: 0,
    quantity: 0,
    item_free_quantity: 0,
    item_batches: [],
    item_discount_amount: 0.0,
    item_total_tax_percentage: 0,
    item_tax_amount: 0,
    item_total_amount: 0,
    item_id: "",
    instock: true,
    item_gst: 0,
    item_sgst: 0,
    item_cgst: 0,
    item_igst:0,
    item_uom_id: "",
    item_manufacturer_id: "",
    pot_id: null,
    pos_id: null,
  };

  const initialFormValues = {
    cmr_code: vendorDetails?.[0]?.cmr_id
      ? {
          label: vendorDetails?.[0]?.cmr_code ?? "",
          value: vendorDetails?.[0]?.cmr_id ?? "",
        }
      : "",
    cmr_name: vendorDetails?.[0]?.cmr_id
      ? {
          label: vendorDetails?.[0]?.cmr_name,
          value: vendorDetails?.[0]?.cmr_id,
        }
      : "",
    cmr_id: vendorDetails?.[0]?.cmr_id,
    remarks: vendorDetails?.[0]?.remarks ?? "",
    is_inter_state:vendorDetails?.[0]?.gst_type === "Inter"?true:vendorDetails?.[0]?.gst_type === "Intra"?false:null,
    sct_id: vendorDetails?.[0]?.sct_id || null,
    sct_order_date: vendorDetails?.[0]?.sct_order_date
      ? moment(vendorDetails?.[0]?.sct_order_date).format("YYYY-MM-DD")
      : moment(new Date()).format("YYYY-MM-DD"),
    sct_document_date: vendorDetails?.[0]?.sct_document_date
      ? moment(vendorDetails?.[0]?.sct_document_date).format("YYYY-MM-DD")
      : moment(new Date()).format("YYYY-MM-DD"),
    sct_delivery_date: vendorDetails?.[0]?.sct_delivery_date
      ? moment(vendorDetails?.[0]?.sct_delivery_date).format("YYYY-MM-DD")
      : moment(new Date()).format("YYYY-MM-DD"),
    pot_id: vendorDetails?.[0]?.pot_id ?? null,
    pos_id: vendorDetails?.[0]?.pos_id ?? null,
    sct_sub_total: vendorDetails?.[0]?.sct_sub_total || "0.00",
    sct_total_discount: vendorDetails?.[0]?.sct_total_discount ?? 0,
    sct_total_gst: vendorDetails?.[0]?.sct_total_gst || "0.00",
    sct_round_off_value: vendorDetails?.[0]?.sct_round_off_value || "0.00",
    sct_total_amount: vendorDetails?.[0]?.sct_total_amount || "0.00",
    cmr_tcs: "",
    cmr_tds: "",
    sct_tcs_or_tds_percentage_id:
      vendorDetails?.[0]?.tcs_or_tds_percentage_id ?? "",
    sct_tcs_or_tds_percentage: vendorDetails?.[0]?.tcs_or_tds_percentage ?? 0,
    sct_tds_tcs_type: vendorDetails?.[0]?.tds_tcs_type ?? "",
    sct_tcs_or_tds_amount: vendorDetails?.[0]?.tcs_or_tds_amount ?? 0,
    sct_order_status: vendorDetails?.[0]?.sct_order_status ?? "",
    sct_custom_invoice_number: vendorDetails?.[0]?.sct_custom_invoice_number ?? null,
    sct_is_invoice_dis_percentage:
      vendorDetails?.[0]?.sct_is_invoice_dis_percentage ?? true,
    sct_invoice_discount: vendorDetails?.[0]?.sct_invoice_discount ?? 0,
    sct_invoice_discount_percentage:
      vendorDetails?.[0]?.sct_invoice_discount_percentage ?? 0,
    sct_pay_to_address: payto, //new
    sct_ship_to_address: shipto, //new
    header_dis_per: "",
    header_inv_dis_per: vendorDetails?.[0]?.sct_is_invoice_dis_percentage
      ? vendorDetails?.[0]?.sct_invoice_discount_percentage
      : vendorDetails?.[0]?.sct_invoice_discount,

    data: [
      ...orderDetail?.map((item, index) => ({
        sl_no: index + 1,
        item_code: item?.item_code,
        item_generic_name: item?.item_generic_name,
        item_name: item?.item_name,
        item_hsn: item?.item_hsn,
        item_manufacturer_name: item?.item_manufacturer_name,
        item_uom: item?.item_uom ?? "--",
        item_to_be_delivered: item?.item_credit_quanity_remaining,
        quantity: type === "sales" ? 0 : item?.item_quantity,
        item_free_quantity: parseInt(item?.item_free_quantity ?? 0) ?? 0,
        item_batches:
          type === "sales" || isClone
            ? []
            : item?.itemBatchData?.map((batch) => ({
                item_batch_number: batch?.item_batch_number ?? 0,
                item_batch_quantity: parseInt(batch?.item_batch_quantity) || 0,
                gst_type: vendorDetails?.[0]?.gst_type,
                item_batch_free_quantity:
                  parseInt(batch?.item_batch_free_quantity) || 0,
                item_batch_sales_rate:
                  parseFloat(batch?.item_batch_sales_rate) || 0,
                item_batch_total_base_sales_rate:
                  parseFloat(batch?.item_batch_total_base_sales_rate) || 0,
                item_batch_discount_percentage:
                  parseFloat(batch?.item_batch_discount_percentage) || 0,
                item_batch_discount_amount:
                  parseFloat(batch?.item_batch_discount_amount) || 0,
                item_batch_discounted_sales_rate:
                  parseFloat(batch?.item_batch_discounted_sales_rate) || 0,
                item_batch_tax_percentage:
                  parseFloat(batch?.item_batch_tax_percentage) || 0,
                item_batch_tax_amount:
                  parseFloat(batch?.item_batch_tax_amount) || 0,
                item_batch_final_sales_rate:
                  parseFloat(batch?.item_batch_final_sales_rate) || 0,
                item_batch_total_sales_rate:
                  parseFloat(batch?.item_batch_total_sales_rate) || 0,
                item_batch_cgst_percentage:
                  parseFloat(batch?.item_batch_cgst_percentage) || 0,
                item_batch_sgst_percentage:
                  parseFloat(batch?.item_batch_sgst_percentage) || 0,
                item_batch_igst_percentage:
                  parseFloat(batch?.item_batch_igst_percentage) || 0,
                item_batch_sgst_amount:
                  parseFloat(batch?.item_batch_sgst_amount) || 0,
                item_batch_cgst_amount:
                  parseFloat(batch?.item_batch_cgst_amount) || 0,
                item_batch_igst_amount:
                  parseFloat(batch?.item_batch_igst_amount) || 0,
                item_batch_unit_price:
                  parseFloat(batch?.item_batch_unit_price) || 0,
                item_exp_date: batch?.item_exp_date
                  ? moment(batch?.item_exp_date).format("YYYY-MM-DD")
                  : null, // Default to a date if not provided
                item_id: batch?.item_id ?? 0,
                from_bin_location: batch?.from_bin_location ?? "",
                from_bin_id: batch?.from_bin_id ?? 0,
                item_batch_avail_quantity: parseInt(batch?.item_batch_quantity),
              })) ?? [],
        item_discount_amount: item?.item_discount_amount,
        item_total_tax_percentage: item?.item_total_tax_percentage,
        item_tax_amount: item?.item_tax_amount ?? 0,
        item_total_amount: item?.item_total_amount,
        item_id: item?.item_id,
        ...(item?.soit_id 
          ? { soit_id: item?.soit_id }
          : { soit_id: null }),
        ...(item?.srt_id
          ? { srt_id: item?.srt_id }
          : { srt_id: null }),
        instock: true,
        item_gst: item?.item_gst,
        item_cgst: item?.item_cgst,
        item_sgst: item?.item_sgst,
        item_igst: item?.item_igst,
        uom_dropdown: item?.uom_dropdown
          ? item?.uom_dropdown.map((uom) => ({
              item_uom_id: uom?.item_id,
              label: uom?.alt_uom,
              value: uom?.alt_uom,
              base_quantity: uom?.base_quantity ?? 1,
            }))
          : [],
        item_uom_id: item?.item_uom_id ?? "",
        item_manufacturer_id: item?.item_manufacturer_id ?? "",
        pot_id: item?.pot_id ?? null,
        pos_id: item?.pos_id ?? null,
        base_quantity: item?.base_quantity ?? 1,
      })),
      initialData,
    ],
  };
  const [initialValue, setInitialValue] = useState(initialFormValues);
  const [reload, setReload] = useState(false);
  const [formValues, setFormValues] = useState({});
  const [storeId, setStoreId] = useState("");
  const [storeDetails, setStoreDetails] = useState({});
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const validationSchema = Yup.object().shape({
    cmr_code: Yup.object().required("Customer code number is required"),
    cmr_name: Yup.object().required("Customer name is required"),
  });

  useEffect(() => {
    dispatch(storeIdAction(onSuccessStore, onErrorStore));
    dispatch(storeDetailsAction(onSuccessStoreDetails, onErrorStoreDetails));
    const data = localStorage.getItem("ModPermission");
    if (data) {
      const parsed = JSON.parse(data);
      const salesdata = parsed.find((obj) => obj?.sales_credit_create);
      if (salesdata?.sales_credit_create) {
        setHeading(salesdata.sales_credit_create);
      }
    }
  }, []);

  const onSuccessStore = (data) => {
    setStoreId(data?.data?.store_id);
    setReload(!reload);
  };
  const onErrorStore = () => {};
  const onSuccessStoreDetails = (data) => {
    setStoreDetails(data?.data);
  };
  const onErrorStoreDetails = () => {};

  const onErrorOrder = (data) => {
    setButtonLoading(false);

    errorToast(data?.data?.message);
  };
  const handleSubmit = (values) => {
    if(values.data.length <=1 && values.data[0].item_code ===""){
      errorToast("Please add at least one item");
      return;
    }
    const missingUOM = values?.data
      ?.slice(0, -1)
      .some((item) => !item.item_uom);
    if(!values?.sct_pay_to_address){
      errorToast("Please verify and save the address");
          return;
    }
    if(!values?.sct_ship_to_address){
      errorToast("Please verify and save the address");
          return;
    }
    const data=    {
      orderData: {
        is_draft_order: values.submittedButton === "draft" ? true : false,
        store_id: storeId,
        ...(values?.sct_id ? { sct_id: values?.sct_id } : {}),

        // ✅ numeric-safe
        sct_total_gst: num0(values?.sct_total_gst),
        sct_total_discount: num0(values?.sct_total_discount),
        sct_total_amount: num0(values?.sct_total_amount),
        sct_sub_total: num0(values?.sct_sub_total),
        sct_round_off_value: num0(values?.sct_round_off_value),

        sct_payment_status: "paid",
        sct_transaction_id: "",
        sct_billing_address: "",

        cmr_code: values?.cmr_code?.label,
        cmr_id: values?.cmr_id,
        cmr_name: values?.cmr_name?.label,
        remarks: values?.remarks,
        sct_order_date: values?.sct_order_date,
        sct_custom_invoice_number:values?.sct_custom_invoice_number,
        sct_document_date: values?.sct_document_date,
        sct_delivery_date: values?.sct_delivery_date,
        pot_id: values?.pot_id ?? null,
        pos_id: values?.pos_id ?? null,

        sct_tcs_or_tds_percentage_id: values?.sct_tcs_or_tds_percentage_id ?? "",
        sct_tcs_or_tds_percentage: num0(values?.sct_tcs_or_tds_percentage),
        sct_tds_tcs_type: values?.sct_tds_tcs_type ?? "",
        sct_tcs_or_tds_amount: num0(values?.sct_tcs_or_tds_amount),

        sct_is_invoice_dis_percentage: values?.sct_is_invoice_dis_percentage,

        // ✅ numeric-safe
        sct_invoice_discount: num0(values?.sct_invoice_discount),
        sct_invoice_discount_percentage: num0(values?.sct_invoice_discount_percentage),

        sct_pay_to_address: values?.sct_pay_to_address || null,
        sct_ship_to_address: values?.sct_ship_to_address || null,
        gst_type:values?.is_inter_state===false?"Intra":"Inter"
      },

      itemData: values.data?.slice(0, -1).map((item) => ({
        item_code: item?.item_code,
        item_generic_name: item?.item_generic_name,
        item_name: item?.item_name,
        item_hsn: item?.item_hsn,
        ...(values?.sct_id ? { sct_id: values?.sct_id } : {}),
        // ✅ ints
        item_quantity: int0(item?.quantity),
        item_free_quantity: int0(item?.item_free_quantity),

        item_batch_number: item?.item_batch_number,
        item_schedule: item?.item_schedule,

        // ✅ numeric-safe
        item_discount_amount: num0(item?.item_discount_amount),
        item_total_tax_percentage: num0(item?.item_total_tax_percentage),
        item_tax_amount: num0(item?.item_tax_amount),
        item_total_amount: num0(item?.item_total_amount),

        item_id: item?.item_id,
        ...(item?.soit_id ? { soit_id: item?.soit_id } : {}),
        ...(item?.srt_id ? { srt_id: item?.srt_id } : {}),

        // ✅ numeric-safe
        item_gst: num0(item?.item_gst),
        item_sgst: num0(item?.item_sgst),
        item_cgst: num0(item?.item_cgst),
        item_igst: num0(item?.item_igst),
        item_uom_id: item?.item_uom_id ?? "",
        item_uom: item?.item_uom ?? "",
        item_manufacturer_id: item?.item_manufacturer_id ?? "",
        item_manufacturer_name: item?.item_manufacturer_name ?? "",
        pot_id: item?.pot_id ?? null,
        pos_id: item?.pos_id ?? null,
      })),

      itemBatchData: values.data
        ?.slice(0, -1)
        .map((item) => item.item_batches)
        .flat()
        .map((batch) => ({
          item_batch_number: batch?.item_batch_number,
          ...(values?.sct_id ? { sct_id: values?.sct_id } : {}),
          // ✅ ints  
          item_batch_quantity: int0(batch?.item_batch_quantity),
          item_batch_free_quantity: int0(batch?.item_batch_free_quantity),

          // ✅ numeric-safe
          item_batch_sales_rate: num0(batch?.item_batch_sales_rate),
          item_batch_total_base_sales_rate: num0(batch?.item_batch_total_base_sales_rate),
          item_batch_discount_percentage: num0(batch?.item_batch_discount_percentage),
          item_batch_discount_amount: num0(batch?.item_batch_discount_amount),
          item_batch_discounted_sales_rate: num0(batch?.item_batch_discounted_sales_rate),
          item_batch_tax_percentage: num0(batch?.item_batch_tax_percentage),
          item_batch_tax_amount: num0(batch?.item_batch_tax_amount),
          item_batch_final_sales_rate: num0(batch?.item_batch_final_sales_rate),
          item_batch_total_sales_rate: num0(batch?.item_batch_total_sales_rate),
          item_batch_unit_price: num0(batch?.item_batch_unit_price),

          item_exp_date: batch?.item_exp_date,
          item_id: batch?.item_id,
          from_bin_location: batch?.from_bin_location,
          from_bin_id: batch?.from_bin_id,
        })),
    }
    if (
      page === "edit" 
      // &&
      // values?.submittedButton !== "draft" &&
      // values?.sct_order_status !== "draft"
    ) {
      setButtonLoading(true);

      dispatch(
        salesCreditEditAction(
          data,
          onSuccessOrder,
          onErrorOrder
        )
      );
    } else {
      if (
        values?.data
          ?.slice(0, -1)
          .some(
            (item) => parseInt(item.quantity) === 0 || item.quantity === ""
          ) &&
        values?.submittedButton !== "draft"
      ) {
        errorToast("Quantity cannot be zero");
      } else if (missingUOM && values?.submittedButton !== "draft") {
        errorToast("Please add UOM for all items");
      } else {
        if (values?.data?.length > 0) {
          setButtonLoading(true);

          dispatch(
  salesCreditReceiptCreateAction(
    {
      orderData: {
        is_draft_order: values.submittedButton === "draft" ? true : false,
        store_id: storeId,
        ...(values?.sct_id ? { sct_id: values?.sct_id } : {}),

        // ✅ numeric-safe
        sct_total_gst: num0(values?.sct_total_gst),
        sct_total_discount: num0(values?.sct_total_discount),
        sct_total_amount: num0(values?.sct_total_amount),
        sct_sub_total: num0(values?.sct_sub_total),
        sct_round_off_value: num0(values?.sct_round_off_value),

        sct_payment_status: "paid",
        sct_transaction_id: "",
        sct_billing_address: "",

        cmr_code: values?.cmr_code?.label,
        cmr_id: values?.cmr_id,
        cmr_name: values?.cmr_name?.label,
        remarks: values?.remarks,
        sct_order_date: values?.sct_order_date,
        sct_custom_invoice_number:values?.sct_custom_invoice_number,
        sct_document_date: values?.sct_document_date,
        sct_delivery_date: values?.sct_delivery_date,
        pot_id: values?.pot_id ?? null,
        pos_id: values?.pos_id ?? null,

        sct_tcs_or_tds_percentage_id: values?.sct_tcs_or_tds_percentage_id ?? "",
        sct_tcs_or_tds_percentage: num0(values?.sct_tcs_or_tds_percentage),
        sct_tds_tcs_type: values?.sct_tds_tcs_type ?? "",
        sct_tcs_or_tds_amount: num0(values?.sct_tcs_or_tds_amount),

        sct_is_invoice_dis_percentage: values?.sct_is_invoice_dis_percentage,

        // ✅ numeric-safe
        sct_invoice_discount: num0(values?.sct_invoice_discount),
        sct_invoice_discount_percentage: num0(values?.sct_invoice_discount_percentage),

        sct_pay_to_address: values?.sct_pay_to_address || null,
        sct_ship_to_address: values?.sct_ship_to_address || null,
        gst_type:values?.is_inter_state===false?"Intra":"Inter"
      },

      itemData: values.data?.slice(0, -1).map((item) => ({
        item_code: item?.item_code,
        item_generic_name: item?.item_generic_name,
        item_name: item?.item_name,
        item_hsn: item?.item_hsn,

        // ✅ ints
        item_quantity: int0(item?.quantity),
        item_free_quantity: int0(item?.item_free_quantity),

        item_batch_number: item?.item_batch_number,
        item_schedule: item?.item_schedule,

        // ✅ numeric-safe
        item_discount_amount: num0(item?.item_discount_amount),
        item_total_tax_percentage: num0(item?.item_total_tax_percentage),
        item_tax_amount: num0(item?.item_tax_amount),
        item_total_amount: num0(item?.item_total_amount),

        item_id: item?.item_id,
        ...(item?.soit_id ? { soit_id: item?.soit_id } : {}),
        ...(item?.srt_id ? { srt_id: item?.srt_id } : {}),

        // ✅ numeric-safe
        item_gst: num0(item?.item_gst),
        item_sgst: num0(item?.item_sgst),
        item_cgst: num0(item?.item_cgst),
        item_igst: num0(item?.item_igst),
        item_uom_id: item?.item_uom_id ?? "",
        item_uom: item?.item_uom ?? "",
        item_manufacturer_id: item?.item_manufacturer_id ?? "",
        item_manufacturer_name: item?.item_manufacturer_name ?? "",
        pot_id: item?.pot_id ?? null,
        pos_id: item?.pos_id ?? null,
      })),

      itemBatchData: values.data
        ?.slice(0, -1)
        .map((item) => item.item_batches)
        .flat()
        .map((batch) => ({
          item_batch_number: batch?.item_batch_number,

          // ✅ ints
          item_batch_quantity: int0(batch?.item_batch_quantity),
          item_batch_free_quantity: int0(batch?.item_batch_free_quantity),

          // ✅ numeric-safe
          item_batch_sales_rate: num0(batch?.item_batch_sales_rate),
          item_batch_total_base_sales_rate: num0(batch?.item_batch_total_base_sales_rate),
          item_batch_discount_percentage: num0(batch?.item_batch_discount_percentage),
          item_batch_discount_amount: num0(batch?.item_batch_discount_amount),
          item_batch_discounted_sales_rate: num0(batch?.item_batch_discounted_sales_rate),
          item_batch_tax_percentage: num0(batch?.item_batch_tax_percentage),
          item_batch_tax_amount: num0(batch?.item_batch_tax_amount),
          item_batch_final_sales_rate: num0(batch?.item_batch_final_sales_rate),
          item_batch_total_sales_rate: num0(batch?.item_batch_total_sales_rate),
          item_batch_unit_price: num0(batch?.item_batch_unit_price),

          item_exp_date: batch?.item_exp_date,
          item_id: batch?.item_id,
          from_bin_location: batch?.from_bin_location,
          from_bin_id: batch?.from_bin_id,
        })),
    },
    onSuccessOrder,
    onErrorOrder
  )
);

        }
      }
    }
  };

  const onSuccessOrder = (data) => {
    setButtonLoading(false);

    // Notify parent that form was saved
    if (onFormSaved) {
      onFormSaved();
    }

    if (formValues?.submittedButton === "print") {
      handlea4Print(
        data?.data?.orderData?.sct_id,
        "sales_credit_note",
        dispatch
      );
    }
    navigate("/sales-credit-note");
    successToast(data?.message);
    setInitialValue({
      cmr_code: "",
      cmr_name: "",
      cmr_id: "",
      remarks: "",
      sct_total_discount: 0,
      sct_order_date: null,
      sct_document_date: null,
      sct_delivery_date: null,
      data: [initialData],
    });
  };
  useHotkeys("escape", () => {
    setAddbatch(false);
  });

  // Auto draft function for address sidebar
  const autoDraft = (values) => {
    if (values?.data?.length > 1) {
      setButtonLoading(true);
      setTimeout(() => {
        // If sct_id exists, use edit/update action
        if (values?.sct_id) {
          dispatch(
            salesCreditEditAction(
              {
                orderData: {
                  is_draft_order: true,
                  store_id: storeId,
                  sct_id: values?.sct_id,
                  sct_total_gst: num0(values?.sct_total_gst),
                  sct_total_discount: num0(values?.sct_total_discount),
                  sct_payment_status: "paid",
                  sct_transaction_id: "",
                  sct_billing_address: "",
                  sct_total_amount: num0(values?.sct_total_amount),
                  sct_sub_total: num0(values?.sct_sub_total),
                  cmr_code: values?.cmr_code?.label,
                  cmr_id: values?.cmr_id,
                  cmr_name: values?.cmr_name?.label,
                  remarks: values?.remarks,
                  sct_order_date: values?.sct_order_date,
                  sct_custom_invoice_number: values?.sct_custom_invoice_number,
                  sct_document_date: values?.sct_document_date,
                  sct_delivery_date: values?.sct_delivery_date,
                  pot_id: values?.pot_id ?? null,
                  pos_id: values?.pos_id ?? null,
                  sct_round_off_value: num0(values?.sct_round_off_value),
                  sct_tcs_or_tds_percentage_id:
                    values?.sct_tcs_or_tds_percentage_id ?? "",
                  sct_tcs_or_tds_percentage:
                    num0(values?.sct_tcs_or_tds_percentage),
                  sct_tds_tcs_type: values?.sct_tds_tcs_type ?? "",
                  sct_tcs_or_tds_amount: num0(values?.sct_tcs_or_tds_amount),
                  sct_is_invoice_dis_percentage:
                    values?.sct_is_invoice_dis_percentage,
                  sct_invoice_discount: num0(values?.sct_invoice_discount),
                  sct_invoice_discount_percentage:
                    num0(values?.sct_invoice_discount_percentage),
                  sct_pay_to_address: values?.sct_pay_to_address || null,
                  sct_ship_to_address: values?.sct_ship_to_address || null,
                  gst_type: values?.is_inter_state === false ? "Intra" : "Inter",
                },
                itemData: values.data?.slice(0, -1).map((item) => ({
                  item_code: item?.item_code,
                  item_generic_name: item?.item_generic_name,
                  item_name: item?.item_name,
                  item_hsn: item?.item_hsn,
                  sct_id: values?.sct_id,
                  item_quantity: int0(item?.quantity),
                  item_free_quantity: int0(item?.item_free_quantity),
                  item_batch_number: item?.item_batch_number,
                  item_schedule: item?.item_schedule,
                  item_discount_amount: num0(item?.item_discount_amount),
                  item_total_tax_percentage: num0(item?.item_total_tax_percentage),
                  item_tax_amount: num0(item?.item_tax_amount),
                  item_total_amount: num0(item?.item_total_amount),
                  item_id: item?.item_id,
                  ...(item?.soit_id ? { soit_id: item?.soit_id } : {}),
                  ...(item?.srt_id ? { srt_id: item?.srt_id } : {}),
                  item_gst: num0(item?.item_gst),
                  item_sgst: num0(item?.item_sgst),
                  item_cgst: num0(item?.item_cgst),
                  item_igst: num0(item?.item_igst),
                  item_uom_id: item?.item_uom_id ?? "",
                  item_uom: item?.item_uom ?? "",
                  item_manufacturer_id: item?.item_manufacturer_id ?? "",
                  item_manufacturer_name: item?.item_manufacturer_name ?? "",
                  pot_id: item?.pot_id ?? null,
                  pos_id: item?.pos_id ?? null,
                })),
                itemBatchData: values.data
                  ?.slice(0, -1)
                  .map((item) => item.item_batches)
                  .flat()
                  .map((batch) => ({
                    item_batch_number: batch?.item_batch_number,
                    sct_id: values?.sct_id,
                    item_batch_quantity: int0(batch?.item_batch_quantity),
                    item_batch_free_quantity: int0(batch?.item_batch_free_quantity),
                    item_batch_sales_rate: num0(batch?.item_batch_sales_rate),
                    item_batch_total_base_sales_rate: num0(batch?.item_batch_total_base_sales_rate),
                    item_batch_discount_percentage: num0(batch?.item_batch_discount_percentage),
                    item_batch_discount_amount: num0(batch?.item_batch_discount_amount),
                    item_batch_discounted_sales_rate: num0(batch?.item_batch_discounted_sales_rate),
                    item_batch_tax_percentage: num0(batch?.item_batch_tax_percentage),
                    item_batch_tax_amount: num0(batch?.item_batch_tax_amount),
                    item_batch_final_sales_rate: num0(batch?.item_batch_final_sales_rate),
                    item_batch_total_sales_rate: num0(batch?.item_batch_total_sales_rate),
                    item_batch_unit_price: num0(batch?.item_batch_unit_price),
                    item_exp_date: batch?.item_exp_date || null,
                    item_id: batch?.item_id,
                    from_bin_location: batch?.from_bin_location,
                    from_bin_id: batch?.from_bin_id,
                  })),
              },
              (data) => {
                setButtonLoading(false);
                successToast(data?.message);
                navigate(
                  `/edit-customer-admin/${values?.cmr_id}?backto=/edit-sales-credit/${values?.sct_id}`,
                  {
                    state: { tab: "Address" },
                  }
                );
              },
              (data) => {
                setButtonLoading(false);
                errorToast(data?.data?.message);
              }
            )
          );
        } else {
          // For new/add mode, use create action
          dispatch(
            salesCreditReceiptCreateAction(
              {
                orderData: {
                  is_draft_order: true,
                  store_id: storeId,
                  sct_total_gst: num0(values?.sct_total_gst),
                  sct_total_discount: num0(values?.sct_total_discount),
                  sct_payment_status: "paid",
                  sct_transaction_id: "",
                  sct_billing_address: "",
                  sct_total_amount: num0(values?.sct_total_amount),
                  sct_sub_total: num0(values?.sct_sub_total),
                  cmr_code: values?.cmr_code?.label,
                  cmr_id: values?.cmr_id,
                  cmr_name: values?.cmr_name?.label,
                  remarks: values?.remarks,
                  sct_order_date: values?.sct_order_date,
                  sct_custom_invoice_number: values?.sct_custom_invoice_number,
                  sct_document_date: values?.sct_document_date,
                  sct_delivery_date: values?.sct_delivery_date,
                  pot_id: values?.pot_id ?? null,
                  pos_id: values?.pos_id ?? null,
                  sct_round_off_value: num0(values?.sct_round_off_value),
                  sct_tcs_or_tds_percentage_id:
                    values?.sct_tcs_or_tds_percentage_id ?? "",
                  sct_tcs_or_tds_percentage:
                    num0(values?.sct_tcs_or_tds_percentage),
                  sct_tds_tcs_type: values?.sct_tds_tcs_type ?? "",
                  sct_tcs_or_tds_amount: num0(values?.sct_tcs_or_tds_amount),
                  sct_is_invoice_dis_percentage:
                    values?.sct_is_invoice_dis_percentage,
                  sct_invoice_discount: num0(values?.sct_invoice_discount),
                  sct_invoice_discount_percentage:
                    num0(values?.sct_invoice_discount_percentage),
                  sct_pay_to_address: values?.sct_pay_to_address || null,
                  sct_ship_to_address: values?.sct_ship_to_address || null,
                  gst_type: values?.is_inter_state === false ? "Intra" : "Inter",
                },
                itemData: values.data?.slice(0, -1).map((item) => ({
                  item_code: item?.item_code,
                  item_generic_name: item?.item_generic_name,
                  item_name: item?.item_name,
                  item_hsn: item?.item_hsn,
                  item_quantity: int0(item?.quantity),
                  item_free_quantity: int0(item?.item_free_quantity),
                  item_batch_number: item?.item_batch_number,
                  item_schedule: item?.item_schedule,
                  item_discount_amount: num0(item?.item_discount_amount),
                  item_total_tax_percentage: num0(item?.item_total_tax_percentage),
                  item_tax_amount: num0(item?.item_tax_amount),
                  item_total_amount: num0(item?.item_total_amount),
                  item_id: item?.item_id,
                  ...(item?.soit_id ? { soit_id: item?.soit_id } : {}),
                  ...(item?.srt_id ? { srt_id: item?.srt_id } : {}),
                  item_gst: num0(item?.item_gst),
                  item_sgst: num0(item?.item_sgst),
                  item_cgst: num0(item?.item_cgst),
                  item_igst: num0(item?.item_igst),
                  item_uom_id: item?.item_uom_id ?? "",
                  item_uom: item?.item_uom ?? "",
                  item_manufacturer_id: item?.item_manufacturer_id ?? "",
                  item_manufacturer_name: item?.item_manufacturer_name ?? "",
                  pot_id: item?.pot_id ?? null,
                  pos_id: item?.pos_id ?? null,
                })),
                itemBatchData: values.data
                  ?.slice(0, -1)
                  .map((item) => item.item_batches)
                  .flat()
                  .map((batch) => ({
                    item_batch_number: batch?.item_batch_number,
                    item_batch_quantity: int0(batch?.item_batch_quantity),
                    item_batch_free_quantity: int0(batch?.item_batch_free_quantity),
                    item_batch_sales_rate: num0(batch?.item_batch_sales_rate),
                    item_batch_total_base_sales_rate: num0(batch?.item_batch_total_base_sales_rate),
                    item_batch_discount_percentage: num0(batch?.item_batch_discount_percentage),
                    item_batch_discount_amount: num0(batch?.item_batch_discount_amount),
                    item_batch_discounted_sales_rate: num0(batch?.item_batch_discounted_sales_rate),
                    item_batch_tax_percentage: num0(batch?.item_batch_tax_percentage),
                    item_batch_tax_amount: num0(batch?.item_batch_tax_amount),
                    item_batch_final_sales_rate: num0(batch?.item_batch_final_sales_rate),
                    item_batch_total_sales_rate: num0(batch?.item_batch_total_sales_rate),
                    item_batch_unit_price: num0(batch?.item_batch_unit_price),
                    item_exp_date: batch?.item_exp_date || null,
                    item_id: batch?.item_id,
                    from_bin_location: batch?.from_bin_location,
                    from_bin_id: batch?.from_bin_id,
                  })),
              },
              (data) => {
                setButtonLoading(false);
                successToast(data?.message);
                navigate(
                  `/edit-customer-admin/${values?.cmr_id}?backto=/edit-sales-credit/${data?.data?.orderData?.sct_id}`,
                  {
                    state: { tab: "Address" },
                  }
                );
              },
              (data) => {
                setButtonLoading(false);
                errorToast(data?.data?.message);
              }
            )
          );
        }
      }, 500);
    }
  };

  // Component to track form changes
  const FormChangeTracker = () => {
    const { values } = useFormikContext();

    useEffect(() => {
      // Don't track changes if form was just saved
      if (isFormSaved) {
        console.log("=== SALES CREDIT NOTE FORM CHANGE TRACKER ===");
        console.log("Form was saved, not tracking changes");
        if (onUnsavedChangesChange) {
          onUnsavedChangesChange(false);
        }
        return;
      }

      const hasChanges =
        JSON.stringify(initialValue) !== JSON.stringify(values);
      console.log("=== SALES CREDIT NOTE FORM CHANGE TRACKER ===");
      console.log("Form change detected:", hasChanges);
      console.log("Initial values:", initialValue);
      console.log("Current values:", values);

      if (onUnsavedChangesChange) {
        onUnsavedChangesChange(hasChanges);
      }
    }, [values, initialValue, isFormSaved, onUnsavedChangesChange]);

    return null;
  };

  return (
    <Formik
      enableReinitialize={true}
      initialValues={initialValue}
      validationSchema={validationSchema}
      onSubmit={(values, actions) => {
        setTimeout(() => {
          handleSubmit(values, actions); // Pass values and actions if needed
          actions.setSubmitting(false); // Notify Formik that submission is done
        }, 500);
      }}
    >
      {({ values }) => {
        setFormValues(values);
        return (
          <Form className="h-full">
            <FormChangeTracker />
            <div
              style={{
                height: `calc(100% - 8rem)`,
              }}
              className="mx-5 flex flex-col h-full "
            >
              <SalesRCNBatchesPanel
                searchRef={searchRef}
                open={addbatch}
                setOpen={setAddbatch}
                disabled={disabled}
                setItemId={setItemId}
                itemId={itemId}
                itemValues={values}
                prefix="sct"
              />
              <SalesPurchaseNavbar
                clickedplus={clickedplus}
                isClone={isClone}
                pageType={pageType}
                page={page}
                isCusInvNumRequired={false}
                section="sales"
                name="sct"
                disabled={disabled}
                searchRef={searchRef}
                autoDraft={autoDraft}
              />

              <SalesItemsSection
                isClone={isClone}
                clickedplus={clickedplus}
                heading={heading}
                standAlone={standAlone}
                // qtyDis={true}
                type={type}
                disabled={values.is_inter_state===null || disabled}
                addBatchFn={(id) => {
                  setAddbatch(true);
                  
                  setItemId(id);
                }}
                searchRef={searchRef}
                initialData={initialData}
                isNotViewOnly = {isNotViewOnly}
                prefixName="sct"
              />
            </div>
            <SalesPurchaseFooter
              modules="sales"
              EditFn={() => {
                navigate(`/edit-sales-credit/${values?.sct_id}`);
              }}
              transaction="Sales Credit Note"
              transaction_type="sales_credit_note"
              buttonLoading={buttonLoading}
              name="sct_total_discount"
              page={page}
              disabled={disabled}
              prefixName="sct"
              tcsTdsAmount={tcsTdsAmount}
              setTcsTdsAmount={setTcsTdsAmount}
            />
          </Form>
        );
      }}
    </Formik>
  );
};

export default CreateEditViewSalesCN;
